export default {
  states: (state) => state.states,
  location: (state) => state.location,
  locations: (state) => state.locations,
  kpiStats: (state) => state.kpiStats
}



// WEBPACK FOOTER //
// ./src/store/modules/location/getters.js